module.exports = __webpack_public_path__ + "static/winter-a18fad366413891f65251e5091427f30.gif";